import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import pageTemplateService from './routes/service'
import team from './routes/team'
import about from './routes/about'
import pageTemplateDrZehr from './routes/dr-zehr'
import pageTemplateTestimonials from './routes/testimonials'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	pageTemplateService,
	team,
	about,
	pageTemplateDrZehr,
	pageTemplateTestimonials,
})

/** Load Events */
routes.loadEvents()
